import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResolvedApprovalStep } from '../approval/models/approval-flow.model';

@Component({
  selector: 'app-approval-flow-preview',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="approval-flow-preview" *ngIf="steps && steps.length > 0">
      <div class="preview-header">
        <i class="fas fa-route"></i>
        <span>簽核流程預覽</span>
      </div>
      
      <div class="flow-steps">
        <div 
          *ngFor="let step of steps; let i = index" 
          class="step-item"
          [class.has-error]="step.error"
        >
          <div class="step-number">{{ step.level }}</div>
          <div class="step-content">
            <div class="step-name">{{ step.stepName }}</div>
            <div class="step-approver">
              <span class="approver-name">{{ step.approverName }}</span>
              <span *ngIf="step.isDynamicDepartment" class="dynamic-badge">動態</span>
            </div>
            <div *ngIf="step.error" class="step-error">
              <i class="fas fa-exclamation-triangle"></i>
              {{ step.error }}
            </div>
          </div>
          <div *ngIf="i < steps.length - 1" class="step-arrow">
            <i class="fas fa-arrow-down"></i>
          </div>
        </div>
      </div>
      
      <div *ngIf="hasErrors" class="error-summary">
        <i class="fas fa-exclamation-triangle"></i>
        <span>簽核流程配置存在問題，請檢查設定</span>
      </div>
    </div>
  `,
  styleUrls: ['../total-component.scss'],
  styles: [`
    .approval-flow-preview {
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 6px;
      padding: 16px;
      margin-top: 8px;
    }

    .preview-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 600;
      color: #495057;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .flow-steps {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .step-item {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      position: relative;
    }

    .step-item.has-error {
      background: #fff5f5;
      border: 1px solid #fed7d7;
      border-radius: 6px;
      padding: 12px;
    }

    .step-number {
      background: #007bff;
      color: white;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 600;
      flex-shrink: 0;
    }

    .step-item.has-error .step-number {
      background: #dc3545;
    }

    .step-content {
      flex: 1;
    }

    .step-name {
      font-weight: 600;
      color: #212529;
      margin-bottom: 4px;
    }

    .step-approver {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #6c757d;
    }

    .approver-name {
      color: #495057;
    }

    .dynamic-badge {
      background: #ffc107;
      color: #000;
      font-size: 10px;
      padding: 2px 6px;
      border-radius: 10px;
      font-weight: 600;
    }

    .step-error {
      margin-top: 8px;
      color: #dc3545;
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .step-arrow {
      position: absolute;
      left: 12px;
      top: 30px;
      color: #6c757d;
      font-size: 12px;
    }

    .error-summary {
      margin-top: 16px;
      padding: 12px;
      background: #fff3cd;
      border: 1px solid #ffeaa7;
      border-radius: 6px;
      color: #856404;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  `]
})
export class ApprovalFlowPreviewComponent {
  @Input() steps: ResolvedApprovalStep[] = [];

  get hasErrors(): boolean {
    return this.steps.some(step => step.error);
  }
}